export default __webpack_public_path__ + "static/logo-62508c11e2f98866cd82d6b4106c82df.png";